// Components
import MotivatorsPageLayer from "@Motivators/layouts/MotivatorsPageLayer";
import MotivatorsWrapper from "@Motivators/layouts/MotivatorsWrapper";

// Icons
import SS from "@/assets/icons/motivators/spiffSetup/SS.svg";

const SpiffSetupView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Sales Spiff Setup",
	headerIcon: SS,
	motivatorType: "spiffSetup",
});

export default SpiffSetupView;
